import {
  IChannelNotificationResponse,
  NotificationType
} from "@wingspanhq/notifications/dist/lib/interfaces";
import { NotificationHandleType } from "../components/Notifications";
import { selectorActiveNotifications } from "./selectorActiveNotifications";

type NotificationWithGroup = IChannelNotificationResponse & {
  group: IChannelNotificationResponse[];
};

export const selectorGroupedTodos = (
  notifications: IChannelNotificationResponse[]
) => {
  const result: NotificationWithGroup[] = [];

  selectorActiveNotifications(notifications)
    // Todos should *not* include dismissable notifications
    .filter(notification => notification.type !== NotificationType.Dismissable)
    .forEach(notification => {
      if (
        [
          NotificationHandleType.SignatureCollaborator,
          // NotificationHandleType.BackgroundCheckRequestContractor,
          NotificationHandleType.InsuranceCoverageMonitoringContractor,
          NotificationHandleType.FileSharingRequestContractor,
          NotificationHandleType.SignatureClient,
          NotificationHandleType.W9Consent,
          NotificationHandleType.RequirementPendingReviewClient,
          NotificationHandleType.PayoutMethod
        ].includes(notification.handle as NotificationHandleType) &&
        result.some(r => r.handle === notification.handle)
      ) {
        result
          .find(r => r.handle === notification.handle)
          ?.group.push(notification);
      } else {
        result.push({ ...notification, group: [notification] });
      }
    });

  return result;
};
